const routes = {
	LOGIN: '/login',
	REGISTER: '/register',
	EMAIL_CONFIRM: '/emailconfirm',
	REGISTER_CONFIRM: '/registerconfirm',
	FORGOT_PASSWORD: '/forgotpassword',
	CHANGE_PASSWORD: '/changepassword',
	CONFIRM_PASS_EMAIL: '/confirmpasswordrequest',
	// Passwordless trial/marketing accounts
	MAGIC_LOGIN: '/magic/:token',
	// An email's "Unsubscribe" link (MYD-546); public, the token is the auth
	UNSUBSCRIBE: '/unsubscribe',
	CONVERT_ACCOUNT: '/convert',
	// A plan the Claude.ai connector proposed, confirmed in MDT (MYD-648)
	AI_PLAN: '/ai/plans/:id',

	HOME: '/',
	/**
	 * The desktop home at an address of its own.
	 *
	 * `/` is not enough: on a phone it resolves to the field app, which is
	 * correct and deliberate. This is how somebody asks for the desktop home
	 * anyway, without reintroducing a stored mode that could strand them.
	 */
	DESKTOP_HOME: '/home',
	PROFILE: '/profile',
	COMPANY: '/company',
	COMPANY_PROFILE: '/companyprofile',
	USER_PROFILE: '/userprofile',
	TEMPLATES: '/templates',
	TASKTEMPLATES: '/tasktemplates',
	SITEDETAILTEMPLATES: '/sitedetailtemplates',
	APPS: '/apps',
	CREDIT_CARDS: '/creditcards',

	ARCHIVE_LIBRARY: '/archivelibrary',
	CHAT: '/chats',
	COMMUNITY: '/community',
	FLEET: '/fleet',
	LOCATIONS: '/locations',
	LOCATION_PROJECTS: '/locationprojects',
	CENTERS: '/centers',
	EVALUATIONS: '/evaluations',
	// Global evaluation-module routes (SSP parity). Each page lists evaluations
	// and embeds the matching workspace once one is picked. Wired in MYD-181.
	COMPARE: '/compare',
	SCORING: '/scoring',
	FINANCIALS: '/financials',
	RISKS: '/risks',
	PROSCONS: '/proscons',
	APPROVALS: '/approvals',
	REPORTS: '/reports',
	// Operator-wide listing of every site across all of their evaluations,
	// labelled "Evaluation Sites" and nested under MAIN/Evaluations in the
	// sidebar, alongside Approvals. Constant name kept as ALL_SITES for
	// back-compat with existing imports.
	ALL_SITES: '/evaluation-sites',
	// Previous home of the page, under ADMIN/Archives. Still routed so old
	// links and bookmarks keep working; the sidebar no longer points here.
	ALL_SITES_LEGACY: '/admin/archives/sites',
	PORTFOLIOS: '/portfolios',
	PROJECTS: '/projects',
	PARTNERAPPS: '/partnerapps',
	TASKSCN: '/taskscn',
	// Explorer is grain-parameterised: /explorer redirects to the first
	// available grain so a bare link always lands somewhere real.
	EXPLORER: '/explorer',
	EXPLORER_GRAIN: '/explorer/:grain',
	EXPLORER_LOCATIONS: '/explorer/locations',
	// Presentations (MYD-494). Only the present route works on a phone; the
	// gallery and editor are desktop-only (see desktopOnlyRoutes.ts). All three
	// are behind REACT_APP_PRESENTATIONS_ENABLED until the editor and presenter
	// ship.
	PRESENTATIONS: '/presentations',
	PRESENTATION_EDIT: '/presentations/:id/edit',
	PRESENTATION_PRESENT: '/presentations/:id/present',
	// The presenter's second window: notes, next slide, timer (MYD-497).
	PRESENTATION_PRESENTER_VIEW: '/presentations/:id/presenter-view',
	// A public share link to a published snapshot (MYD-509). Signed out.
	PRESENTATION_SHARE: '/share/presentation/:token',
	PARTNERS: '/partners',
	UPDATE_TASK: `/updatetask`,

	ADMIN: '/admin',
	ADMIN_TEMPLATES: '/admin/templates',
	ADMIN_TRIAL_USERS: '/admin/trial-users',
	ADMIN_SUPPORT: '/admin/support',
	/*
	 * Support > Help Docs.
	 *
	 * A CHILD of /admin/support rather than that path itself, which already
	 * renders the impersonation tool. Support is a section meant to grow, so the
	 * documents live one level down and the tool keeps the address it has.
	 */
	ADMIN_HELP_DOCS: '/admin/support/help-docs',
	ADMIN_VENDORS: '/admin/vendors',
	OAUTH_AUTHORIZE: '/oauth/authorize',
	// Browser-facing OAuth consent page. Distinct from the backend JSON API at
	// /oauth/authorize so the SPA route renders in production (where the API
	// path is owned by Express). This is the OAuth `authorization_endpoint`.
	OAUTH_CONSENT: '/oauth/consent',
}

export default routes
